<script lang="ts">
	import { Router, Route, Link } from "svelte-navigator";
	import Atributes from "./groups/Groups.svelte";
	import Character from "./character/Character.svelte";
	import Exporter from "./save/Exporter.svelte";
	import Save from "./save/Save.svelte";
	import SpellOverview from "./spells/SpellOverview.svelte";
	import Spells from "./spells/Spells.svelte";
	import Weapons from "./weapons/Weapons.svelte";
	import Groups from "./groups/Groups.svelte";
	import Profession from "./groups/Profession.svelte";
import Printer from "./printer/Printer.svelte";

	let routes = [
		{ route: "", name: "Home" },
		{ route: "chara", name: "Character" },
		{ route: "groups", name: "Gruppen" },
		{ route: "spells", name: "Spruchlisten" },
		{ route: "weapons", name: "Waffen" },
		{ route: "export", name: "Exporter" },
	];
</script>

<Router>
	<div
		class="
	grid
	sm:grid-cols-12
	h-full
"
	>
		<nav class="bg-gray-700 sm:col-span-4 lg:col-span-3 xl:col-span-2">
			<div class="pt-4 p-4">
				<h1 class="pb-4">RM Chargen</h1>
				<Save />
			</div>
			<ul class="pt-4 pb-4">
				{#each routes as route}
					<li class="hover:bg-gray-500">
						<Link class="px-4 block text-lg" to={route.route}
							>{route.name}</Link
						>
					</li>
				{/each}
			</ul>
		</nav>

		<article
			class="
		p-4
		sm:col-span-8
		lg:col-span-9
		xl:col-span-10
	"
		>
			<Route path="/">

				<Printer></Printer>
				<Character />
				<Profession />
				<Groups />
				<Weapons />
				<Spells />

			</Route>

			<Route path="/chara">
				<Character />
			</Route>

			<Route path="groups">
				<Profession />
				<Atributes />
			</Route>

			<Route path="weapons">
				<Profession />
				<Weapons />
			</Route>

			<Route path="spells">
				<h1>Spruchlisten</h1>
				<Spells />
				<SpellOverview />
			</Route>

			<Route path="export">
				<Exporter />
			</Route>
		</article>
	</div>
</Router>
